export const distinctBy = <T, K>(arr: T[], keySelector: (item: T) => K): T[] => {
  const seen = new Map<K, T>();
  for (const item of arr) {
    seen.set(keySelector(item), item); // keeps last occurrence
  }
  return Array.from(seen.values());
};
